<template>
  <div v-if="showToolbar">
    <nav class="navbar fixed-top bg-white">
      <form class="form-inline">
        <button class="btn btn-sm align-middle btn-outline-primary" @click.prevent="goBack" v-show="showBack">
          <icon name='chevron-left' /> Back
        </button>
        <button class="btn btn-sm align-middle btn-outline-dark" @click.prevent="displayMenu = true" v-show="showMenuBtn">
          <icon name='bars' />
        </button>
      </form>
      <span class="navbar-text nav-text navbar-center mt-2">
        <img src="../assets/whtbrd-crossdumbbells2.png" class="toolbar-logo">
      </span>
      <form class="form-inline">
        <button class="btn btn-sm align-middle btn-outline-dark" @click.prevent="displayCalendar = true" v-show="showCalendar"><icon name='calendar' /></button>
        <button class="btn btn-sm align-middle btn-outline-dark ml-2" @click.prevent="displaySearch"><icon name='search' /></button>
      </form>
    </nav>

    <kDialog :showModal="displayMenu" typeClass="menu" transition="slide" transEnter="slideInLeft" transLeave="slideOutLeft">
      <div slot="header" class="headerSlot"> 
        <small>App Ver: {{ver}}</small>
        <button class="btn btn-outline-light closeBtn" @click="displayMenu = false">
          <icon name="times" ></icon>
        </button>
      </div>
      <div slot="body" class="centerBody">
        <ul class="list-group menu">
          <li class="list-group-item menuItem mt-3"><icon name="envelope-o"></icon> Messages</li>
          <li class="list-group-item menuItem"><icon name="dashboard"></icon> 1 Rep Max Lifts</li>
          <li class="list-group-item menuItem"><icon name="star"></icon> Named/Open Wods</li>
          <li class="list-group-item menuItem" @click="goToProfile"><icon name="user"></icon> Profile</li>
          <li class="list-group-item menuItem"><icon name="gear"></icon> Settings</li>
          <li class="list-group-item menuItem" @click="goToAdmin" v-if="isAdmin" ><icon name="gear"></icon> Admin</li>

        </ul>
      </div>
    </kDialog>

    <kDialog :showModal="displayCalendar" typeClass="dropDown" transition="slide" transEnter="slideInDown" transLeave="slideOutUp">
      <div slot="body" class="centerBody">
       <v-calendar :attributes='calAttrs' @dayclick='dayClicked' is-expanded></v-calendar>
      </div>
      <div slot="footer" class="footer">
        <button class="btn btn-block btn-outline-light closeBtn" @click="displayCalendar = false">
          <icon name="chevron-up" ></icon> Close Calendar
        </button>
      </div>
    </kDialog>

    <kDialog :showModal="displayDrawer" typeClass="drawer" transition="slide" transEnter="slideInUp" transLeave="slideOutDown">
      <div slot="body" class="centerBody">
       <h4>Which Workout on {{format(selectedDay.date, 'MMM Do')}}?</h4>
       <div class="btn btn-block btn-light workoutBtn" v-for="workout in selectedDay.attributes" @click="goToWorkout(workout.customData.id)" :key="workout.customData.id">
          <span class="badge badge-pill" :class="[workout.customData.type == 'metcon' ? 'badge-primary' : workout.customData.type == 'lift' ? 'badge-secondary' :  'badge-info']">{{workout.customData.type}}</span>
          {{workout.customData.desc}}
       </div>
      </div>
      <div slot="footer" class="footer">
        <button class="btn btn-block btn-outline-light closeBtn" @click="displayDrawer = false">
          <icon name="times-circle" ></icon> Cancel
        </button>
      </div>
    </kDialog>

  </div>
</template>

<script>
/* Im useing route Meta tags to specify if the back button should 
be shown or if the the toolbaar should be shown at all. */

import kDialog from '@/components/kDialog'
import firebase from 'firebase'
import format from 'date-fns/format'
import timestamp from 'unix-timestamp'

export default {

  name: 'toolbar',
  components: {
    kDialog
  },
  props: {
    ver: {
      type: String
    }
    /*
    showback: {
      type: Boolean,
      default: true
    }
    */
  },
  data () {
    return {
      title: 'WhtBrd',
      format: format,
      timestamp: timestamp,
      displayMenu: false,
      displayCalendar: false,
      selectedDay: "",
      displayDrawer: false,
    }
  },
  computed: {
      calAttrs: function() {
        return this.$store.getters.workoutDates.map(workout => ({
          key: workout.id,
          dot: (workout.type == 'metcon') ? {backgroundColor: '#007bff'} : {backgroundColor: '#6c757d'},
          dates: workout.date,
          customData: workout
        }))
      },
      showBack: function () {
          if(this.$route.meta.showBack === undefined) {
              return true
          } else {
              return this.$route.meta.showBack
          }     
      },
      isAdmin: function () {
        return this.$store.state.user.admin
      },
      showMenuBtn: function () {
        if(this.$route.name == 'home'){
          return true
        } else {
          return false
        }
      },
      showToolbar: function () {
          if(this.$route.meta.showToolbar === undefined) {
              return true
          } else {
              return this.$route.meta.showToolbar
          }     
      },
      showCalendar: function () {
          if(this.$route.meta.showCalendar === true) {
              return true
          } else {
              return false
          }     
      }
      /*
      workouts: function() {
        return this.$store.state.workouts
      }
      */
  },
  watch: {
    workouts: function() {
      this.calAttrs[1].dates = this.$store.getters.workoutDates.map(date => {return date.date})
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    dayClicked(day) {
      this.selectedDay = day
      this.displayCalendar = false
      if(this.selectedDay.attributes.length < 2) {
        //route to selected workout
        this.$router.push({ name: 'workout', params: { id: this.selectedDay.attributes[0].customData.id }})
      } else {
        //ask which workout they wanted...
        this.drawerDate = timestamp.toDate(this.selectedDay.dateTime)
        this.displayDrawer = true
      }
      //
    },
    goToWorkout: function(id) {
      this.displayDrawer = false
      this.$router.push({ name: 'workout', params: { id: id }})
    },
    goToProfile: function () {
      this.$router.push({ path: '/profile' })
      this.displayMenu = false
    },
    goToAdmin: function () {
      this.$router.push({ path: '/admin' })
      this.displayMenu = false
    },
    logOut() { 
      firebase.auth().signOut().then(() =>{
        this.$store.commit('resetStore')
        this.$router.replace('login')
      })
    },
    displaySearch () {
      this.$router.push('search')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .toolbar-logo {
      width: 90px;
    }
    nav {
        padding-top: 10px;
    }
    .navbar.fixed-top {
      border-radius: 0;
    }
    .navbar {
      height: 60px;
      border-radius: 0;
      border: 0;
      box-shadow: 0px 2px 18px -5px rgba(0,0,0,0.2);
    }
    .navbar-center
    {
        position: absolute;
        width: 100%;
        left: 0;
        top: -3px;
        text-align: center;
        height: 0;
        overflow: visible;
        padding-top: 10px;
    }
    .headerSlot {
      width: 100%;
    }
    .headerSlot > .closeBtn {
      float: right;
    }
    /*
    .menu {
      background-color: #325D88;
      border: 0px;
    }
    */
    .menuItem {
      background-color: #325D88;
      font-size: 1rem;
      text-align: left;
      border-bottom: 1px solid #CCC;
      border-top: 0px;
      border-left: 0px;
      border-right: 0px;
      margin-bottom: 2px;
    }
    .menuItem:last-child {
      border-bottom: 0px;
    }
    .workoutBtn {
      text-overflow: ellipsis;
      overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/toolbar.vue